import { sum } from './core.js'

const headerSumSubLines = (data, operation) => {
    const { fieldsToOperate, targetField, subEntity, subSubEntity } = operation

    if (!data[subEntity] || !Array.isArray(data[subEntity])) {
        return data
    }

    // Create new array with updated elements instead of mutating
    const newSubArray = data[subEntity].map(elem => {
        let result = 0
        
        // Check if subSubEntity exists and is an array
        if (elem[subSubEntity] && Array.isArray(elem[subSubEntity]) && elem[subSubEntity].length > 0) {
            for (const subElem of elem[subSubEntity]) {
                result += sum(subElem, fieldsToOperate)
            }
        }
        
        // Return new element with updated targetField
        return {
            ...elem,
            [targetField]: parseFloat(result.toFixed(2))
        }
    })

    // Return new object with updated array
    return {
        ...data,
        [subEntity]: newSubArray
    }
}

export default headerSumSubLines
